import React from "react";
import mp3 from "../../assets/sounds/order.mp3";
import OrderAPI from "../../services/api/Orders";
import moment from "moment";
import { connect } from "react-redux";
import { addNotify } from "../../services/store/reducers/notify/actions";
import { hasRole, permInUse, roleInUse } from "../../services/Common";
import { withRouter } from "react-router-dom";

let counter = 0;

class Notifications extends React.Component {
    audio = new Audio(mp3);
    state = {};
    timer = null;

    componentDidMount() {
        this.checkChanges();
        this.timer = setInterval(() => {
            this.checkChanges();
        }, 30000);
    }
    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer);
    }
    checkChanges = () => {
        if (roleInUse() && (hasRole("kitchenview_role") || hasRole("courier_role"))) {
            return;
        }
        if (permInUse() && !hasRole("perm_orders_notify")) {
            return;
        }

        let now = moment();
        var subtract = moment.duration("00:00:10");
        now.subtract(subtract);
        OrderAPI.checkChanges(now)
            .then((response) => {
                if (response.length > 0) {
                    this.audio.play();
                    counter++;
                    this.props.addNotify({
                        notify_type: "NEW_ORDER",
                        data: counter
                    });
                }
            })
            .catch((error) => {
                console.log("checkChanges", error);
            });
    };
    render() {
        return null;
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        addNotify: (data) => {
            dispatch(addNotify(data));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Notifications));



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js